import ForBusinesses from './ForBusinesses';

export { ForBusinesses };
export default ForBusinesses;
